import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FileTextIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M4 1.332a1.333 1.333 0 0 0-1.333 1.333v10.667A1.333 1.333 0 0 0 4 14.665h8a1.333 1.333 0 0 0 1.333-1.333v-8l-4-4H4Zm0 1.333h4.667V6H12v7.333H4V2.665ZM5.333 8v1.333h5.334V7.999H5.333Zm0 2.666V12h3.334v-1.334H5.333Z'
        />
    </svg>
));
